import { render, staticRenderFns } from "./StockTransPreviewDialog.vue?vue&type=template&id=67d96c14&scoped=true"
import script from "./StockTransPreviewDialog.vue?vue&type=script&lang=js"
export * from "./StockTransPreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./StockTransPreviewDialog.vue?vue&type=style&index=0&id=67d96c14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d96c14",
  null
  
)

export default component.exports